import { assert, parseUrl, assertWarning, isPlainObject, hasPropertyGetter } from './utils';
export { addComputedUrlProps };
export { assertURLs };
function addComputedUrlProps(pageContext) {
    assert(pageContext.urlOriginal);
    if ('urlPathname' in pageContext) {
        assert(hasPropertyGetter(pageContext, 'urlPathname'));
    }
    else {
        Object.defineProperty(pageContext, 'urlPathname', {
            get: urlPathnameGetter,
            enumerable: true,
            configurable: true
        });
    }
    if ('url' in pageContext) {
        assert(hasPropertyGetter(pageContext, 'url'));
    }
    else {
        Object.defineProperty(pageContext, 'url', {
            get: urlGetter,
            enumerable: false,
            configurable: true
        });
    }
    if ('urlParsed' in pageContext) {
        assert(hasPropertyGetter(pageContext, 'urlParsed'));
    }
    else {
        Object.defineProperty(pageContext, 'urlParsed', {
            get: urlParsedGetter,
            enumerable: true,
            configurable: true
        });
    }
}
function getUrlParsed(pageContext) {
    let urlHandler = pageContext._urlHandler;
    if (!urlHandler) {
        urlHandler = (urlOriginal) => urlOriginal;
    }
    const url = urlHandler(pageContext.urlOriginal);
    const baseServer = pageContext._baseServer;
    assert(baseServer.startsWith('/'));
    return parseUrl(url, baseServer);
}
function urlPathnameGetter() {
    const { pathname } = getUrlParsed(this);
    const urlPathname = pathname;
    assert(urlPathname.startsWith('/'));
    return urlPathname;
}
function urlGetter() {
    assertWarning(false, '`pageContext.url` is outdated. Use `pageContext.urlPathname`, `pageContext.urlParsed`, or `pageContext.urlOriginal` instead. (See https://vite-plugin-ssr.com/migration/0.4.23 for more information.)', { onlyOnce: true, showStackTrace: true });
    return urlPathnameGetter.call(this);
}
function urlParsedGetter() {
    const urlParsedOriginal = getUrlParsed(this);
    const { origin, pathname, pathnameOriginal, search, searchAll, searchOriginal, hash, hashOriginal } = urlParsedOriginal;
    const urlParsed = {
        origin,
        pathname,
        pathnameOriginal,
        search,
        searchAll,
        searchOriginal,
        hash,
        hashOriginal,
        get hashString() {
            assertWarning(false, '`pageContext.urlParsed.hashString` has been renamed to `pageContext.urlParsed.hashOriginal`', { onlyOnce: true, showStackTrace: true });
            return hashOriginal;
        },
        get searchString() {
            assertWarning(false, '`pageContext.urlParsed.searchString` has been renamed to `pageContext.urlParsed.searchOriginal`', { onlyOnce: true, showStackTrace: true });
            return searchOriginal;
        }
    };
    makeNonEnumerable(urlParsed, 'hashString');
    makeNonEnumerable(urlParsed, 'searchString');
    return urlParsed;
}
function makeNonEnumerable(obj, prop) {
    const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    Object.defineProperty(obj, prop, { ...descriptor, enumerable: false });
}
function assertURLs(pageContext) {
    assert(typeof pageContext.urlOriginal === 'string');
    assert(typeof pageContext.urlPathname === 'string');
    assert(isPlainObject(pageContext.urlParsed));
    assert(pageContext.urlPathname === pageContext.urlParsed.pathname);
}
